import ReferralDetails from './src/ReferralDetails';

export default ReferralDetails;
